export const ROOM_NAMES: Record<string, string> = {
  kitchen: 'Кухня',
  corridor: 'Коридор',
  bedroom: 'Спальня',
  bathroom: 'Ванная',
  classroom: 'Класс физики',
  lab: 'Лаборатория',
  gym: 'Спортзал',
  director: 'Кабинет директора',
  sales_floor: 'Торговый зал',
  storage: 'Склад',
  checkout: 'Кассовая зона',
  cold_room: 'Холодильник',
  ward: 'Палата',
  surgery: 'Операционная',
  morgue: 'Морг',
  pharmacy: 'Аптека',
  garage_bay: 'Ремонтный бокс',
  pit: 'Смотровая яма',
  parts_room: 'Склад запчастей',
  office: 'Конторка',
  barracks: 'Казарма',
  armory: 'Оружейная',
  command: 'Штаб',
  checkpoint: 'КПП',
  workshop: 'Цех',
  control_room: 'Пультовая',
  warehouse_fac: 'Склад продукции',
  boiler_room: 'Котельная',
  nave: 'Главный зал',
  altar: 'Алтарь',
  bell_tower: 'Колокольня',
  crypt: 'Крипта',
  lobby: 'Холл',
  hotel_room: 'Номер',
  kitchen_hotel: 'Кухня отеля',
  penthouse: 'Пентхаус',
  reading_hall: 'Читальный зал',
  archive: 'Архив',
  kids_section: 'Детский отдел',
  lib_office: 'Кабинет библиотекаря',
  corridor_b: 'Бетонный коридор',
  control_b: 'Центр управления',
  storage_b: 'Хранилище',
  lab_b: 'Секретная лаб.',
};
